module.exports = __webpack_public_path__ + "static/media/animation_project_central.ca325661.gif";